import { type VendorPaymentMethod } from '@webapp/modules/vendor/entities/VendorPaymentMethod'
import { useCreateVendorPaymentMethodFormPresenter } from './useCreateVendorPaymentMethodFormPresenter'
import { VendorPaymentMethodForm } from '../../views/VendorPaymentMethodForm'

export interface ICreateVendorPaymentMethodFormPresenterProps {
  vendor: { id: number; name: string }
  /** Card currency — pre-selects the currency (BHV-047) */
  defaultCurrencyId?: number
  onCreated: (method: VendorPaymentMethod) => void
  onCancel: () => void
}

// Form content only — the "Add payment method to {provider}" ModalDialog
// wrapper is FS-owned. Exported via the modules/vendor public API (ADR-6).
export const CreateVendorPaymentMethodFormPresenter = ({
  vendor,
  defaultCurrencyId,
  onCreated,
  onCancel,
}: ICreateVendorPaymentMethodFormPresenterProps) => {
  const {
    states: { isCreating },
    methods: { onSubmit },
  } = useCreateVendorPaymentMethodFormPresenter({
    vendorId: vendor.id,
    onCreated,
  })

  return (
    <VendorPaymentMethodForm
      isSaving={isCreating}
      defaultCurrencyId={defaultCurrencyId}
      onSubmit={onSubmit}
      onCancel={onCancel}
    />
  )
}

CreateVendorPaymentMethodFormPresenter.displayName =
  'CreateVendorPaymentMethodFormPresenter'
